























































import { Component, Vue } from "vue-property-decorator";
import { BPopover } from "bootstrap-vue";
import { GapDateFilter } from "@/store/modules/types";
import DatePicker from "vuejs-datepicker";

@Component({
  components: {
    BPopover,
    DatePicker,
  },
})
export default class UpdatedFilter extends Vue {
  id = "updated-filter-popover";
  target = "updated-filter-target";
  filter = this.defaultFilter();
  defaultFilter(): GapDateFilter {
    return {
      from: null,
      to: null,
    };
  }
  search() {
    const filter = { ...this.filter };
    this.$store.commit("gaps/SET_UPDATED_FILTER", filter);
    this.close();
  }
  clear() {
    this.filter = this.defaultFilter();
    this.search();
  }
  close() {
    this.$root.$emit("bv::hide::popover", this.id);
    this.$emit("closed");
  }
  mounted() {
    const { updated } = this.$store.state.gaps.filter;
    this.filter = JSON.parse(JSON.stringify(updated));
  }
}
